import React, { useState, useEffect } from "react";

const CircularScrollProgressWithArrow = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY; // Current vertical position
      const scrollHeight = document.documentElement.scrollHeight; // Total page height
      const clientHeight = document.documentElement.clientHeight; // Visible area height
      const scrollableHeight = scrollHeight - clientHeight;

      const progress = (scrollTop / scrollableHeight) * 100;
      setScrollProgress(progress);

      // Show the progress circle when scrolling down, hide it when at the top
      if (scrollTop > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const radius = 50; // Radius of the circle
  const circumference = 2 * Math.PI * radius; // Circumference of the circle
  const strokeDashoffset = circumference - (scrollProgress / 100) * circumference;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!isVisible) {
    return null; // Don't render if not visible
  }

  return (
    <div style={{ position: "fixed", bottom: "15px", right: "10px", zIndex: 9999 }}>
      <svg
        width="60"
        height="60"
        viewBox="0 0 120 120"
        style={{ transform: "rotate(-90deg)" }} // Rotate to start progress from the top
      >
        {/* Background Circle */}
        <circle
          cx="60"
          cy="60"
          r={radius}
          fill="none"
          stroke="#e0e0e0"
          strokeWidth="3"
        />
        {/* Progress Circle */}
        <circle
          cx="60"
          cy="60"
          r={radius}
          fill="none" 
          stroke="#000"
          strokeWidth="3"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          style={{ transition: "stroke-dashoffset 0.1s ease" }}
        />
      </svg>
      {/* Arrow Button */}
      <div
        onClick={scrollToTop}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          cursor: "pointer",
          fontSize: "24px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
        
          color: "#00a6ff",
        }}
      >
        ↑
      </div>
    </div>
  );
};

export default CircularScrollProgressWithArrow;
